import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleOAuthCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          await handleOAuthCallback(sessionId);
          // Clear hash and redirect to home
          window.history.replaceState(null, '', '/');
          navigate('/', { replace: true });
        } catch (error) {
          console.error('OAuth callback error:', error);
          navigate('/');
        }
      } else {
        navigate('/');
      }
    };

    processCallback();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-black">
      <div className="text-center">
        <Loader2 className="h-12 w-12 text-brand-gold animate-spin mx-auto mb-4" />
        <p className="text-white/60">Connexion en cours...</p>
      </div>
    </div>
  );
}
